import { URLS } from '@/pages/urls'
import { Text } from '@/ui-kit'
import { Trans, useLingui } from '@lingui/react/macro'
import { SquareArrowOutUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'

export const StakingBenefits = () => {
  const { t } = useLingui()

  const benefits = [
    {
      title: t`Earn Airdrops`,
      description: t`Receive standard SOL staking rewards and $DATA airdrops.`
    },
    {
      title: t`Unlock Extra Jobs`,
      description: t`Access more tasks in your DataHive AI account.`
    },
    {
      title: t`Add Extra Devices`,
      description: t`Connect additional workers to increase throughput and earn more points.`
    },
    {
      title: t`Boost Hive Points`,
      description: t`Receive a higher multiplier on Hive points for platform activity.`
    }
  ]

  return (
    <div className="flex flex-col gap-6">
      <Text type="subtitle-semibold">
        <Trans>Staking benefits</Trans>
      </Text>

      <div className="flex flex-col gap-4">
        {benefits.map((benefit) => (
          <div key={benefit.title} className="flex flex-col gap-1">
            <Text type="body1-regular" className="text-gray-70">
              {benefit.title}
            </Text>
            <Text type="body2-regular" className="text-gray-90">
              {benefit.description}
            </Text>
          </div>
        ))}
      </div>

      <div className="mt-6 border-t border-solid border-gray-100 pt-6">
        <Link
          className="group text-gray-70 flex items-center gap-2"
          to={URLS.BLOG_STAKING}
          target="_blank"
          rel="noreferrer"
        >
          <span className="group-hover:text-orange underline transition-colors duration-300">
            <Trans>More information in our blog</Trans>
          </span>
          <SquareArrowOutUpRight
            size={20}
            className="text-gray-90 group-hover:text-orange transition-colors duration-300"
          />
        </Link>
      </div>
    </div>
  )
}
